export class BomPoItemVariant {

    hasTag: string;
    is: string;
    n:string;
    vendorDescription: string;
    use: string;
    qty: string;
    uom:string;
    combo1:string;
    combo2:string;
    combo3:string;
    combo4:string;
    ratio:string;


   
}